import { gql } from 'graphql-tag';

export const createContactListSchedule = gql`
  mutation createContactListSchedule($input: ContactListScheduleInput) {
    createContactListSchedule(input: $input) {
      id
      isPrimary
      startTime
      endTime
      timezone
    }
  }
`;
